import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { EventsService } from "../services/Event";
import { BookingService } from "../services/BookingService";
import { exportBookingsExcel, exportStallBookingsExcel, exportPerformanceBookingsExcel } from "../utils/ExcelExport";
import { StallBookingService } from "../services/StallBookingService";
import { PerformanceBookingService } from "../services/PerformanceBookingService";
import { FaUsers, FaStore, FaMicrophone } from "react-icons/fa";
import logo from "../assets/logo.png";

function Dashboard() {

    const navigate = useNavigate();

    const [events, setEvents] = useState([]);
    /* USER BOOKINGS */
    const [userVenues, setUserVenues] = useState([]);
    const [userEvent, setUserEvent] = useState("");
    const [userVenue, setUserVenue] = useState("");

    /* STALL BOOKINGS */
    const [stallVenues, setStallVenues] = useState([]);
    const [stallEvent, setStallEvent] = useState("");
    const [stallVenue, setStallVenue] = useState("");

    /* PERFORMANCE BOOKINGS (future) */
    const [performanceVenues, setPerformanceVenues] = useState([]);
    const [performanceEvent, setPerformanceEvent] = useState("");
    const [performanceVenue, setPerformanceVenue] = useState("");

    const [userLoading, setUserLoading] = useState(false);
    const [stallLoading, setStallLoading] = useState(false);
    const [performanceLoading, setPerformanceLoading] = useState(false);

    const adminUser = JSON.parse(localStorage.getItem("adminUser"));

    useEffect(() => {
        loadEvents();
    }, []);

    const loadEvents = async () => {

        const res = await EventsService.getAllEvents();
        setEvents(res || []);

    };

    const handleDownload = async () => {

        if (!userEvent || !userVenue) {
            alert("Please select Event and Venue");
            return;
        }

        try {

            setUserLoading(true);

            const bookings = await BookingService.getUserBookingsByVenue(userVenue);

            exportBookingsExcel(bookings);
            setUserEvent("");
            setUserVenue("");
            setUserVenues([]);

        } catch (error) {

            console.error(error);
            alert("Failed to generate Excel");

        } finally {

            setUserLoading(false);

        }

    };

    const handleStallDownload = async () => {

        if (!stallEvent || !stallVenue) {
            alert("Please select Event and Venue");
            return;
        }

        try {

            setStallLoading(true);

            const bookings = await StallBookingService.getStallBookingsByVenue(stallVenue);

            exportStallBookingsExcel(bookings);
            setStallEvent("");
            setStallVenue("");
            setStallVenues([]);

        } catch (error) {

            console.error(error);
            alert("Failed to generate Stall bookings Excel");

        } finally {

            setStallLoading(false);

        }

    };

    const handlePerformanceDownload = async () => {

        if (!performanceEvent || !performanceVenue) {
            alert("Please select Event and Venue");
            return;
        }

        try {

            setPerformanceLoading(true);

            const bookings = await PerformanceBookingService.getPerformanceBookingsByVenue(performanceVenue);

            exportPerformanceBookingsExcel(bookings);

            setPerformanceEvent("");
            setPerformanceVenue("");
            setPerformanceVenues([]);

        } catch (error) {

            console.error(error);
            alert("Failed to generate Performance bookings Excel");

        } finally {

            setPerformanceLoading(false);

        }

    };

    const handleUserEventChange = (eventId) => {

        setUserEvent(eventId);
        setUserVenue("");

        const event = events.find(e => String(e.eventId) === eventId);

        if (!event) return;

        const venueList = (event.eventVenues || []).map(v => ({
            id: v.eventVenueId,
            name: `${v.eventVenue} - ${v.eventVenueDate}`
        }));

        setUserVenues(venueList);

    };

    const handleStallEventChange = (eventId) => {

        setStallEvent(eventId);
        setStallVenue("");

        const event = events.find(e => String(e.eventId) === eventId);

        if (!event) return;

        const venueList = (event.eventVenues || []).map(v => ({
            id: v.eventVenueId,
            name: `${v.eventVenue} - ${v.eventVenueDate}`
        }));

        setStallVenues(venueList);

    };

    const handleLogout = () => {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
        navigate("/");
    };

    return (

        <Container className="mt-5">

            <Row className="align-items-center mb-4">

                <Col md={6}>
                    <h2 className="mb-1">Admin Dashboard</h2>

                    {adminUser && (
                        <div style={{ fontSize: "14px", color: "#666" }}>
                            Welcome <b>{adminUser.name} ...</b>
                        </div>
                    )}

                </Col>

                <Col md={6} className="text-end">

                    {adminUser?.role === "SuperAdmin" && (
                        <Button
                            variant="secondary"
                            className="me-2"
                            onClick={() => navigate("/admin-users")}
                        >
                            Admin Users
                        </Button>
                    )}

                    <Button variant="danger" onClick={handleLogout}>
                        Logout
                    </Button>

                </Col>

            </Row>


            <Row className="g-4">

                {/* USER BOOKINGS */}
                <Col md={4}>
                    <Card className="p-4 dashboard-card">

                        <h6 className="mb-3 text-center fw-semibold">
                            <FaUsers style={{ marginRight: "6px" }} />
                            Download User Bookings
                        </h6>

                        <Form.Select
                            className="mb-2"
                            value={userEvent}
                            onChange={(e) => handleUserEventChange(e.target.value)}
                        >

                            <option value="">Select Event</option>

                            {events.map(ev => (
                                <option key={ev.eventId} value={ev.eventId}>
                                    {ev.eventName}
                                </option>
                            ))}

                        </Form.Select>

                        <Form.Select
                            className="mb-3"
                            value={userVenue}
                            onChange={(e) => setUserVenue(e.target.value)}
                        >

                            <option value="">Select Venue</option>

                            {userVenues.map(v => (
                                <option key={v.id} value={v.id}>
                                    {v.name}
                                </option>
                            ))}

                        </Form.Select>

                        <Button
                            size="sm"
                            onClick={handleDownload}
                            disabled={!userVenue || userLoading}
                        >
                            {userLoading ? "Generating Excel..." : "Download Excel"}
                        </Button>

                    </Card>
                </Col>


                {/* STALL BOOKINGS */}
                <Col md={4}>
                    <Card className="p-4 dashboard-card">

                        <h6 className="mb-3 text-center fw-semibold">
                            <FaStore style={{ marginRight: "6px" }} />
                            Download Stall Bookings
                        </h6>

                        <Form.Select
                            className="mb-2"
                            value={stallEvent}
                            onChange={(e) => handleStallEventChange(e.target.value)}
                        >

                            <option value="">Select Event</option>

                            {events.map(ev => (
                                <option key={ev.eventId} value={ev.eventId}>
                                    {ev.eventName}
                                </option>
                            ))}

                        </Form.Select>

                        <Form.Select
                            className="mb-3"
                            value={stallVenue}
                            onChange={(e) => setStallVenue(e.target.value)}
                        >

                            <option value="">Select Venue</option>

                            {stallVenues.map(v => (
                                <option key={v.id} value={v.id}>
                                    {v.name}
                                </option>
                            ))}

                        </Form.Select>

                        <Button
                            size="sm"
                            onClick={handleStallDownload}
                            disabled={!stallVenue || stallLoading}
                        >
                            {stallLoading ? "Generating Excel..." : "Download Excel"}
                        </Button>

                    </Card>
                </Col>


                {/* PERFORMANCE BOOKINGS */}
                <Col md={4}>
                    <Card className="p-4 dashboard-card">

                        <h6 className="mb-3 text-center fw-semibold">
                            <FaMicrophone style={{ marginRight: "6px" }} />
                            Download Performance Bookings
                        </h6>

                        <Form.Select
                            className="mb-2"
                            value={performanceEvent}
                            onChange={(e) => {

                                const eventId = e.target.value;
                                setPerformanceEvent(eventId);
                                setPerformanceVenue("");

                                const event = events.find(e => String(e.eventId) === eventId);

                                if (!event) return;

                                const venueList = (event.eventVenues || []).map(v => ({
                                    id: v.eventVenueId,
                                    name: `${v.eventVenue} - ${v.eventVenueDate}`
                                }));

                                setPerformanceVenues(venueList);

                            }}
                        >

                            <option value="">Select Event</option>

                            {events.map(ev => (
                                <option key={ev.eventId} value={ev.eventId}>
                                    {ev.eventName}
                                </option>
                            ))}

                        </Form.Select>

                        <Form.Select
                            className="mb-3"
                            value={performanceVenue}
                            onChange={(e) => setPerformanceVenue(e.target.value)}
                        >

                            <option value="">Select Venue</option>

                            {performanceVenues.map(v => (
                                <option key={v.id} value={v.id}>
                                    {v.name}
                                </option>
                            ))}

                        </Form.Select>

                        <Button
                            size="sm"
                            onClick={handlePerformanceDownload}
                            disabled={!performanceVenue || performanceLoading}
                        >
                            {performanceLoading ? "Generating Excel..." : "Download Excel"}
                        </Button>

                    </Card>
                </Col>

            </Row>

            <Row className="mt-5">

                <Col className="text-center">

                    <img
                        src={logo}
                        alt="LeoFair"
                        style={{
                            width: "50%",
                            opacity: 0.85
                        }}
                    />

                </Col>

            </Row>

        </Container>

    );

}

export default Dashboard;